<template>
  <div>
    <div v-for="(item, index) in declineReasons" :key="index">
      <b-badge variant="danger">
        {{ item.ResultDescription }}
      </b-badge>
      <!-- b-badge v-if="index < 2" variant="danger">
        {{ item.ResultDescription }}
      </b-badge>
      <b-badge v-if="index === 2 && (showAllDeclineReasons === true)" variant="danger">
        {{ item.ResultDescription }}
      </b-badge>
      <div v-if="index === 2 && (showAllDeclineReasons === false) && declineReasons.length >= 3 ">
        <b-badge variant="danger">
          {{ item.ResultDescription }}
        </b-badge>
        <span class="btn btn-link collapsed ml-3" @click="showAllDeclineReasons = !showAllDeclineReasons">
            Показать все
          </span>
      </div>
      <b-badge v-if="((index > 2) && (index < declineReasons.length - 1)) && (showAllDeclineReasons === true)" variant="danger">
        {{ item.ResultDescription }}
      </b-badge>
      <div v-if="index === (declineReasons.length - 1) && (showAllDeclineReasons === true)">
        <b-badge variant="danger">
          {{ item.ResultDescription }}
        </b-badge>
        <span class="btn btn-link collapsed ml-3" @click="showAllDeclineReasons = !showAllDeclineReasons">
            Скрыть
          </span>
      </div -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "DeclineReasons",
    props: ['declineReasons'],
    data () {
      return {
        showAllDeclineReasons: false
      }
    },
  }
</script>

<style scoped>

</style>
